// СТРОКИ ШАГА 7 (gate + share) — копи-узел, данными, без экрана. B9-1.
//
// ИСТОЧНИК БУКВЫ — спека шага 7 (s9, Notion `3b419875cbb8818dbd17d13a8b95d5e1`), §3 «Field mapping»
// и §13 «Open questions» (все слоты закрыты), а НЕ рендер борда. Борды (`s7-golden-v6.js`,
// `s7-edge-v9.js`) сверяются машинно — `src/render/__parity__/wizard-s7-copy.test.js`.
//
// ⚠️ ДВЕ СТРОКИ БОРД НЕ ПЕЧАТАЕТ, И ЭТО НЕ ОТКРЫТЫЙ СЛОТ. `s7.sent.receipt` и `s7.sent.time`
// рисуются на golden токенами `[ s7.sent.* ]` (`s7-golden-v6.js:17`, помощник `S()`) — нота
// golden называет это конвенцией дизайн-дока. Канон буквы — спека; приёмка этих двух по борду
// невозможна, гард держит обратное: что борд по-прежнему рисует токен.
//
// ⛔ `s7.exchange` — static-hold В ОБОИХ состояниях (`s477.d1`): строка не свапается в
// подтверждение. Подтверждение несёт только receipt-ряд (receipt + time + spam).
//
// ⛔ `s7.ev_pill_trig` в `src/render/findings.js` — другой неймспейс (паспорт), сюда не относится.

export const S7_COPY = {
  /** send-контрол рядом с полем, финал `s478.d7`. */
  'primary.send': 'Send it to me',
  /** квитанция у чека в received; `{email}` — маска адреса, см. `maskEmail` (`s476.d1`). */
  'sent.receipt': 'On its way to {email}.',
  /** таймстамп квитанции (`s476.d1`). */
  'sent.time': 'sent just now',
  /** спам-хинт под квитанцией, статик (`s477.d1`). */
  'sent.spam': 'Not there? Check spam.',
  /** левый лейбл блока двух объектов, держится в gated и received (`s476.d1`, `s477.d2`). */
  'get.lb': 'what you get',
  /** курсив под тёмными Save/Share (`s476.d1` + свап «reading»→«Life Map» `s478.d6`). */
  'card.inert': 'Your card arrives with your Life Map.',
  /** обменная строка над полем, static-hold в обоих состояниях (`s470.d5`, `s477.d1`). */
  exchange: 'Leave an email and we’ll send you the full Life Map.',

  // ---- B9-3: строки экрана gated, буквой §3 спеки (id — строки §3) ----
  /** бровь шага, bank copy R9-канона (`s474.d1`). */
  eyebrow: 'your life · the whole reading',
  /** лейбл-секционер над полем (§3 `s7.where_to.label`). */
  'where_to.label': 'where to',
  /** плейсхолдер пустого поля в gated (§3 `s7.email_field`). */
  'email_field.placeholder': 'your@email.com',
  /** отдельный контрол, тёмно-заблокирован до отправки (§3 `s7.open_cta`, `s475.d1`). */
  open_cta: 'Open your full Life Map',
  /** строка под Open (§3 `s7.open.sub`, `s472.d7`). */
  'open.sub': 'See what we found in your answers.',
  /** счёт плиты разбора — строчный литерал, прописные даёт CSS (§3 `s7.obj.reading`). */
  'obj.reading.count': '§i–§vii · seven sections',
  /** имя плиты разбора (§3 `s7.obj.reading`). */
  'obj.reading.name': 'Full version',
  /** описание плиты разбора (§3 `s7.obj.reading`). */
  'obj.reading.desc': 'Your full Life Map, written out.',
  /** имя объекта-карточки (§3 `s7.card.name`, `s470.d5`). */
  'card.name': 'Your shareable card',
  /** описание карточки (§3 `s7.obj.card`). */
  'obj.card.desc': 'Anonymised — no names, nothing private',
  /** чип блока объектов и акт-строка locked-карточки в gated (§3 `s7.get.lb.chip`, `s778.d1`). */
  'get.lb.chip': '[ enter email ]',

  // ---- B9-4: received, мост, обложка, отказ отправки — буквой §3 спеки (id — строки §3) ----
  /** чип блока объектов в received (§3 `s7.get.lb.chip`, `s778.d1`: gated → received). */
  'get.lb.chip.yours': '[ yours ]',
  /** акт под инертной карточкой, тёмный в v1 (§3 `s7.card.save`, `s470.d5`). */
  'card.save': 'Save image',
  /** второй акт там же (§3 `s7.card.share`, `s470.d5`). */
  'card.share': 'Share',
  /** питч-строка моста, frozen слово (§3 `s7.bridge.line`, `s468.d1`; знак — U+2019, `s711.d2`). */
  'bridge.line': 'A map shows you where you are. Now it’s your move.',
  /** кнопка моста → authormode.co (§3 `s7.bridge.cta`). */
  'bridge.cta': 'So what happens next?',
  /** подпись под раскрытой обложкой (§3 `s7.cover.note`, `s470.d5`). */
  'cover.note': 'The first page of your Life Map.',
  /** заголовок строки отказа над Open, ember (§3 краевые `s7.err.send.hd`, `s472.d8`; U+2019). */
  'err.send.hd': 'The email didn’t send.',
  /** продолжение той же строки (§3 краевые `s7.err.send.sub`, `s472.d8`). */
  'err.send.sub': 'Your Life Map is right here — open it below.',
  /**
   * контрол в поле received, возвращает его в редактирование. ⚠️ Отдельного id в §3 нет: слово
   * стоит в строке `s7.email_field` («“Change” возвращает его в редактирование», §3/§4) и литералом
   * в golden v6 (`<span class="edit ed">Change</span>`). Взято оттуда — решение CC, названо в сдаче.
   */
  'email_field.change': 'Change',
  /** mono-чип плиты разбора в received (§5 «обе несут mono-чип “tap”»; `readThumb(true)` борда). */
  'obj.reading.tap': 'tap',

  // ---- B9-5: края edge v9 — буквой §3 спеки (краевые строки, `s472.d8`; U+2019 по `s711.d2`) ----
  /** строка невалидного адреса под полем, ember (§3 краевые `s7.err.email`; E1 `s7-edge-v9.js:39`). */
  'err.email': 'That address isn’t complete yet.',
  /**
   * микро-абзац под полем (§3 `s7.where_to.microcopy`, bank · session 22). Дом — краевые состояния,
   * не happy path (`s755.d1`): из печатаемых экранов она стоит только на E1 (`s7-edge-v9.js:40`).
   */
  'where_to.microcopy': 'We’ll send your Life Map and occasionally something from the course if it’s relevant. No spam.',
  /** статус пустой плиты, пока обложка не готова (§3 краевые `s7.pending.cover`; E4b `s7-edge-v9.js:6`). */
  'pending.cover': 'DRAWING THE FIRST PAGE',
};

/** Куда ведёт мост (§3 `s7.bridge.cta`: «→ authormode.co home», cold path). */
export const BRIDGE_HREF = 'https://authormode.co';

/**
 * Титул шага (§3 `s7.title`, `s470.d5`): «Your Life Map» курсивом амбером, перенос, «is ready.».
 * Две части, а не строка с разметкой: перенос — часть набора, а не копи.
 */
export const S7_TITLE = { em: 'Your Life Map', rest: 'is ready.' };

/**
 * Маска адреса для квитанции — форма спеки (§3 `s7.sent.receipt`, §13): «первая буква + •••»,
 * домен целиком: `kyrylo@gmail.com` → `k•••@gmail.com`.
 *
 * ⚠️ Маскирует ТОЛЬКО квитанция. Поле в `received` показывает полный адрес (`s755.d2`): поле читает
 * владелец, квитанцию — чужие глаза (документ уезжает в public-share). Сводить нельзя.
 *
 * Вход — адрес, уже прошедший структурную валидацию шага (B9-2). Адрес без `@` — ошибка вызова,
 * а не форма копи: формы маски для него в спеке нет.
 */
export function maskEmail(email) {
  const at = String(email).lastIndexOf('@');
  // Сам адрес в текст ошибки НЕ кладётся (`s946.d3`): сообщение уходит в Sentry.
  if (at < 1) throw new TypeError('maskEmail: вход не адрес (нет `@` после первого символа)');
  return `${email[0]}•••${email.slice(at)}`;
}

/**
 * Структурная валидация поля адреса — три исхода (`s932.d1`, B9-2):
 *   `empty`   — E8: send `off`, ошибки нет;
 *   `invalid` — E1: send `off`, печатается `s7.err.email`;
 *   `valid`   — send `on`.
 * Правила решения, и больше ничего (это структура, не RFC; доставку проверяет отправка, E2):
 *   1. края обрезаются, после обрезки пусто → `empty`;
 *   2. ровно один `@`, локальная часть не пуста;
 *   3. домен — метки через `.`, минимум две, ни одна не пуста; последняя (tld) — только латиница, ≥ 2;
 *   4. пробел внутри → `invalid`.
 * Момент запуска (blur / пауза в наборе) — забота экрана, не функции.
 */
export function validateEmail(raw) {
  const s = String(raw ?? '').trim();
  if (s === '') return 'empty';
  if (/\s/.test(s)) return 'invalid';
  const parts = s.split('@');
  if (parts.length !== 2) return 'invalid';
  const [local, domain] = parts;
  if (local === '') return 'invalid';
  const labels = domain.split('.');
  if (labels.length < 2 || labels.some((l) => l === '')) return 'invalid';
  if (!/^[A-Za-z]{2,}$/.test(labels[labels.length - 1])) return 'invalid';
  return 'valid';
}

/** Строка квитанции с маской адреса. */
export const sentReceipt = (email) => S7_COPY['sent.receipt'].replace('{email}', maskEmail(email));
